import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import { useSelector, useDispatch } from "react-redux";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser } from "../../store/actions";
import { facebook, google } from "../../config";
import logoSm from "../../assets/images/logo-removebg-preview.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import { Row, Col } from "reactstrap";
const Login = (props) => {
  document.title = "Login | LuxBilling";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      UserName: "",
      password: "",
    },
    validationSchema: Yup.object({
      UserName: Yup.string().required("Please Enter UserName"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  const { error } = useSelector((state) => ({
    error: state.login.error,
  }));

  useEffect(() => {
    document.body.className = "bg-pattern";
    document.body.style.overflow = "hidden";
    return function cleanup() {
      document.body.className = "";
      document.body.style.overflow = "";
    };
  }, []);

  const handleRouteResetPage = () => {
    navigate("/ResetPassword");
  };

  const getPasswordInputStyles = () => ({
    width: "100%",
    padding: window.innerWidth < 768 ? "5px" : "7px",
    background: isHovered
      ? "linear-gradient(90deg, rgba(37, 99, 235, 0.1), rgba(139, 92, 246, 0.1))"
      : "transparent",
    border:
      validation.touched.password && validation.errors.password
        ? "1px solid #dc3545"
        : isFocused
        ? "1px solid #2563eb"
        : "1px solid rgba(255, 255, 255, 0.5)",
    borderRadius: "4px",
    fontSize: window.innerWidth < 768 ? "13px" : "15px",
    color: "#ffffff", // Always visible text
    outline: "none",
    transition: "border-color 0.3s, box-shadow 0.3s, background 0.3s",
    caretColor: "#ffffff",
    boxShadow: isHovered ? "0 0 6px rgba(37, 99, 235, 0.5)" : "none",
    backgroundColor: "transparent",
    WebkitBoxShadow: "0 0 0px 1000px transparent inset",
  });

  return (
    <React.Fragment>
      <div
        className="bg-overlay"
        style={{
          background:
            "linear-gradient(135deg, rgba(0, 0, 255, 0.2), rgba(0, 255, 255, 0.2))",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        {/* Animated Billing Cards */}
        <div
          className="billing-card"
          style={{
            position: "absolute",
            top: window.innerWidth < 768 ? "5%" : "10%",
            left: window.innerWidth < 768 ? "2%" : "5%",
            animation: "floatUp 8s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-credit-card"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
        <div
          className="billing-card"
          style={{
            position: "absolute",
            top: window.innerWidth < 768 ? "55%" : "60%",
            right: window.innerWidth < 768 ? "2%" : "10%",
            animation: "floatUp 9s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-receipt"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
        <div
          className="billing-card"
          style={{
            position: "absolute",
            bottom: window.innerWidth < 768 ? "5%" : "15%",
            left: window.innerWidth < 768 ? "15%" : "20%",
            animation: "floatUp 10s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-currency-usd"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
        <div
          className="billing-card"
          style={{
            position: "absolute",
            top: window.innerWidth < 768 ? "15%" : "20%",
            right: window.innerWidth < 768 ? "5%" : "15%",
            animation: "floatUp 8.5s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-wallet"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
        <div
          className="billing-card"
          style={{
            position: "absolute",
            bottom: window.innerWidth < 768 ? "20%" : "25%",
            left: window.innerWidth < 768 ? "5%" : "10%",
            animation: "floatUp 9.5s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-bank"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
        <div
          className="billing-card"
          style={{
            position: "absolute",
            top: window.innerWidth < 768 ? "25%" : "30%",
            left: window.innerWidth < 768 ? "35%" : "40%",
            animation: "floatUp 8.2s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-calculator"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
        <div
          className="billing-card"
          style={{
            position: "absolute",
            bottom: window.innerWidth < 768 ? "5%" : "10%",
            right: window.innerWidth < 768 ? "25%" : "30%",
            animation: "floatUp 9.2s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-cart"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
        <div
          className="billing-card"
          style={{
            position: "absolute",
            top: window.innerWidth < 768 ? "45%" : "50%",
            left: window.innerWidth < 768 ? "25%" : "30%",
            animation: "floatUp 8.8s ease-in-out infinite",
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(5px)",
              borderRadius: "12px",
              padding: window.innerWidth < 768 ? "8px" : "16px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: window.innerWidth < 768 ? "70px" : "100px",
              height: window.innerWidth < 768 ? "50px" : "70px",
            }}
          >
            <i
              className="mdi mdi-cash"
              style={{
                fontSize: window.innerWidth < 768 ? "20px" : "36px",
                color: "#ffffff",
              }}
            ></i>
          </div>
        </div>
      </div>
      <Container
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
          overflow: "hidden",
          mt: "5vh",
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={9} md={7} lg={6} xl={6}>
            <Card
              sx={{
                background: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "8px",
                boxShadow:
                  "0 8px 15px rgba(255, 255, 255, 0.3), 8px 8px 15px rgba(255, 255, 255, 0.2)", // White glow at bottom and right
                border: "1px solid rgba(255, 255, 255, 0.3)",
                p: { xs: 1.5, sm: 2.5, md: 3 },
                minHeight: { xs: "400px", sm: "420px", md: "450px" },
              }}
            >
              <CardContent>
                <Grid container direction="column" alignItems="center">
                  <Grid item>
                    <Link to="/">
                      <img
                        src={logoSm}
                        alt="logo-sm-light"
                        style={{
                          height: window.innerWidth < 768 ? "38px" : "48px",
                          marginTop: "-20px",
                          animation: "flip 4s infinite linear",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)", // Black shadow at the bottom
                        }}
                      />
                    </Link>
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: "18px", sm: "20px", md: "23px" },
                        color: "#ffffff",
                        mt: 1,
                        textAlign: "center",
                      }}
                    >
                      Welcome to LuxBilling
                    </Typography>
                  </Grid>
                </Grid>
                <form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: window.innerWidth < 768 ? "10px" : "14px",
                  }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  {loading ? (
                    <Box sx={{ my: { xs: 2, md: 4 }, textAlign: "center" }}>
                      <CircularProgress
                        sx={{
                          color: "#ffffff",
                          width: { xs: "28px", md: "36px" },
                          height: { xs: "28px", md: "36px" },
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#ffffff",
                          fontSize: { xs: "13px", md: "15px" },
                          mt: 1,
                        }}
                      >
                        Loading...
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      {error ? (
                        <Box
                          sx={{
                            background: "rgba(220, 53, 69, 0.9)",
                            color: "#ffffff",
                            p: 1,
                            borderRadius: "4px",
                            mb: { xs: 1, md: 1.5 },
                            fontSize: { xs: "11px", md: "13px" },
                          }}
                        >
                          {error}
                        </Box>
                      ) : null}
                      <Box component="div">
                        <Grid container spacing={{ xs: 1, md: 1.5 }}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <label
                              style={{
                                display: "block",
                                fontSize:
                                  window.innerWidth < 768
                                    ? "11px"
                                    : window.innerWidth < 1024
                                    ? "12px"
                                    : "13px",
                                color: "#ffffff",
                                marginBottom: "16px",
                              }}
                            >
                              User Name
                            </label>
                            <input
                              name="UserName"
                              placeholder="Enter User Name"
                              type="text"
                              className="transparent-input"
                              autoComplete="username"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.UserName || ""}
                              style={{
                                border:
                                  validation.touched.UserName &&
                                  validation.errors.UserName
                                    ? "1px solid #dc3545"
                                    : undefined,
                                backgroundColor: "transparent",
                                color: "#ffffff", // Always visible text
                                boxShadow: "none",
                                outline: "none",
                                WebkitBoxShadow:
                                  "0 0 0px 1000px transparent inset",
                              }}
                            />
                            {validation.touched.UserName &&
                            validation.errors.UserName ? (
                              <div
                                style={{
                                  color: "#fecaca",
                                  fontSize:
                                    window.innerWidth < 768 ? "9px" : "11px",
                                  marginTop: "3px",
                                }}
                              >
                                {validation.errors.UserName}
                              </div>
                            ) : null}
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <label
                              style={{
                                display: "block",
                                fontSize:
                                  window.innerWidth < 768
                                    ? "11px"
                                    : window.innerWidth < 1024
                                    ? "12px"
                                    : "13px",
                                color: "#ffffff",
                                marginBottom: "16px",
                              }}
                            >
                              Password
                            </label>
                            <div
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <input
                                name="password"
                                value={validation.values.password || ""}
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                autoComplete="current-password"
                                onChange={validation.handleChange}
                                onBlur={(e) => {
                                  validation.handleBlur(e);
                                  setIsFocused(false);
                                }}
                                onFocus={() => setIsFocused(true)}
                                onMouseOver={() => setIsHovered(true)}
                                onMouseOut={() => setIsHovered(false)}
                                style={getPasswordInputStyles()}
                              />
                              <span
                                onClick={toggleShowPassword}
                                style={{
                                  position: "absolute",
                                  right: "6px",
                                  cursor: "pointer",
                                  color: "#d1d5db",
                                  fontSize:
                                    window.innerWidth < 768 ? "16px" : "18px",
                                }}
                                onMouseOver={(e) =>
                                  (e.currentTarget.style.color = "#2563eb")
                                }
                                onMouseOut={(e) =>
                                  (e.currentTarget.style.color = "#d1d5db")
                                }
                              >
                                {showPassword ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </span>
                            </div>
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <div
                                style={{
                                  color: "#fecaca",
                                  fontSize:
                                    window.innerWidth < 768 ? "9px" : "11px",
                                  marginTop: "3px",
                                }}
                              >
                                {validation.errors.password}
                              </div>
                            ) : null}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            style={{ marginTop: "20px" }}
                          >
                            <button
                              type="submit"
                              className="animated-gradient"
                              onMouseOver={(e) => {
                                e.currentTarget.style.transform = "scale(1.05)";
                                e.currentTarget.style.boxShadow =
                                  "0 0 10px rgba(139, 92, 246, 0.5)";
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow = "none";
                              }}
                              onMouseDown={(e) =>
                                (e.currentTarget.style.transform =
                                  "scale(0.98)")
                              }
                              onMouseUp={(e) =>
                                (e.currentTarget.style.transform =
                                  "scale(1.05)")
                              }
                            >
                              Log In
                            </button>
                          </Grid>
                          {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div
                              style={{
                                marginTop: window.innerWidth < 768 ? "10px" : "14px",
                                textAlign: "center",
                              }}
                            >
                              <h5
                                style={{
                                  fontSize: window.innerWidth < 768 ? "11px" : window.innerWidth < 1024 ? "12px" : "13px",
                                  marginBottom: "10px",
                                  color: "#ffffff",
                                }}
                              >
                                Sign in with
                              </h5>
                              <ul
                                style={{
                                  listStyle: "none",
                                  padding: 0,
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: window.innerWidth < 768 ? "10px" : "14px",
                                }}
                              >
                                <li>
                                  <FacebookLogin
                                    appId={facebook.APP_ID}
                                    autoLoad={false}
                                    callback={() => {}}
                                    render={(renderProps) => (
                                      <Link
                                        to="#"
                                        style={{
                                          background: "#3b5998",
                                          color: "#ffffff",
                                          border: "1px solid #3b5998",
                                          borderRadius: "4px",
                                          padding: window.innerWidth < 768 ? "5px" : "7px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: window.innerWidth < 768 ? "28px" : "36px",
                                          height: window.innerWidth < 768 ? "28px" : "36px",
                                          transition: "background 0.3s",
                                        }}
                                        onClick={renderProps.onClick}
                                        onMouseOver={(e) => (e.currentTarget.style.background = "#2f477a")}
                                        onMouseOut={(e) => (e.currentTarget.style.background = "#3b5998")}
                                      >
                                        <i className="mdi mdi-facebook" style={{ fontSize: window.innerWidth < 768 ? "16px" : "18px" }}></i>
                                      </Link>
                                    )}
                                  />
                                </li>
                                <li>
                                  <GoogleLogin
                                    clientId={google.CLIENT_ID}
                                    render={(renderProps) => (
                                      <Link
                                        to="#"
                                        style={{
                                          background: "#dc3545",
                                          color: "#ffffff",
                                          border: "1px solid #dc3545",
                                          borderRadius: "4px",
                                          padding: window.innerWidth < 768 ? "5px" : "7px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: window.innerWidth < 768 ? "28px" : "36px",
                                          height: window.innerWidth < 768 ? "28px" : "36px",
                                          transition: "background 0.3s",
                                        }}
                                        onClick={renderProps.onClick}
                                        onMouseOver={(e) => (e.currentTarget.style.background = "#b02a37")}
                                        onMouseOut={(e) => (e.currentTarget.style.background = "#dc3545")}
                                      >
                                        <i className="mdi mdi-google" style={{ fontSize: window.innerWidth < 768 ? "16px" : "18px" }}></i>
                                      </Link>
                                    )}
                                    onSuccess={() => {}}
                                    onFailure={() => {}}
                                  />
                                </li>
                              </ul>
                            </div>
                          </Grid> */}
                        </Grid>
                      </Box>
                    </>
                  )}
                  {/* <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: { xs: 0.75, md: 0.5 },
                      fontSize: { xs: "11px", sm: "12px", md: "13px" },
                      fontWeight: "bold",
                      color: "#ffffff",
                    }}
                  >
                    <Typography>Remember me</Typography>
                    <Typography
                      sx={{
                        color: "#2563eb",
                        textDecoration: "underline",
                        cursor: "pointer",
                        "&:hover": { color: "#1d4ed8" },
                      }}
                      onClick={handleRouteResetPage}
                    >
                      Forget Password
                    </Typography>
                  </Box> */}
                </form>

                {/* <Box
              sx={{
                textAlign: "center",
                color: "rgba(255, 255, 255, 0.5)",
                mt: { xs: 1.5, md: 2.5 },
                fontSize: { xs: "11px", md: "13px" },
              }}
            >
              <Typography>
                Don't have an account?{" "}
                <Link
                  to="/register"
                  style={{
                    fontWeight: "500",
                    color: "#2563eb",
                    textDecoration: "none",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#1d4ed8")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "#2563eb")}
                >
                  Register
                </Link>
              </Typography>
              <Typography>
                © {new Date().getFullYear()} Upzet. Crafted with{" "}
                <i style={{ color: "#dc3545" }} className="mdi mdi-heart"></i>{" "}
                by Themesdesign
              </Typography>
            </Box> */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    width: "80%",
                    pb: { xs: 1, sm: 1.5, md: 1.8 },
                    textAlign: "center",
                    color: "#ffffff",
                    fontSize: { xs: "11px", sm: "12px", md: "13px" },
                  }}
                >
                  <Container fluid>
                    <Row >
                      <Col xs={12} sm={6} className="text-center text-sm-start">
                        {new Date().getFullYear()} © LuxBilling.
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        className="text-center text-sm-end mt-3 mt-sm-0"
                      >
                        <div className="text-sm-end d-none d-sm-block">
                          Powered by{" "}
                          <i className="mdi mdi-rocket-launch text-primary"></i>{" "}
                          TARS
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <style>
        {`
          .transparent-input {
            width: 100%;
            padding: ${window.innerWidth < 768 ? "5px" : "7px"};
            background: transparent;
            border: 1px solid rgba(255, 255, 255, 0.5);
            border-radius: 6px;
            font-size: ${window.innerWidth < 768 ? "13px" : "15px"};
            color: #ffffff; // Always visible text
            outline: none;
            transition: border-color 0.3s, box-shadow 0.3s, background 0.3s;
            caret-color: #ffffff;
          }

          .transparent-input::placeholder {
            color: #d1d5db;
          }

          .transparent-input:focus {
            border-color: #2563eb;
            background: rgba(37, 99, 235, 0.05);
          }

          .transparent-input:hover {
            box-shadow: 0 0 6px rgba(37, 99, 235, 0.5);
            background: linear-gradient(90deg, rgba(37, 99, 235, 0.1), rgba(139, 92, 246, 0.1));
          }

          .animated-gradient {
            background: linear-gradient(270deg, #2563eb, #8b5cf6, #2563eb);
            background-size: 600% 600%;
            animation: gradientMove 6s ease infinite;
            border-radius: 12px;
            color: #fff;
            padding: ${window.innerWidth < 768 ? "8px" : "10px"};
            border: none;
            font-size: ${window.innerWidth < 768 ? "13px" : "15px"};
            font-weight: 600;
            cursor: pointer;
            transition: transform 0.2s, box-shadow 0.3s;
            width: 100%;
          }

          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }

          @keyframes floatUp {
            0% { opacity: 0; transform: translateY(0); }
            10% { opacity: 1; }
            50% { opacity: 1; transform: translateY(${
              window.innerWidth < 768 ? "-25px" : "-40px"
            }); }
            90% { opacity: 0; }
            100% { opacity: 0; transform: translateY(0); }
          }

          @keyframes flip {
            0% { transform: rotateY(0deg); }
            100% { transform: rotateY(360deg); }
          }

          @media (max-width: 768px) {
            .transparent-input {
              padding: 5px;
              font-size: 13px;
            }
            .animated-gradient {
              padding: 8px;
              font-size: 13px;
            }
            .billing-card {
              transform: scale(0.7);
            }
          }

          @media (min-width: 768px) and (max-width: 1024px) {
            .transparent-input {
              padding: 6px;
              font-size: 14px;
            }
            .animated-gradient {
              padding: 9px;
              font-size: 14px;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
